module.exports = __webpack_public_path__ + "static/media/logo_smak.2ab85185.jpg";